import i18n from '../../i18n';

export class Text {
  static get manualStart(): string {
    return i18n._translate('Manual Start', {
      context: 'A button that a user can click to begin a regular workout without a trainer.',
    });
  }

  static get manualWorkout(): string {
    return i18n._translate('Manual Workout', {
      context: 'A heading over a description and button indicating the process of how to start a workout manually.',
    });
  }

  static get manualWorkoutDescription(): string {
    return i18n._translate('Move at your own pace with visualized distance and comprehensive metric references.', {
      context: 'A paragraph explaining about starting a manual workout and what the user will see when that happens.',
    });
  }

  static get manualWorkoutButton(): string {
    return i18n._translate('Start manual workout', {
      context: 'A button that indicates when tapping on it will begin a workout manually for the user.',
    });
  }
}
